// Copy to the clipboard and (optionally) wipe it again after 30 s, so secrets
// don't linger. Only clears if the clipboard still holds what we put there.

let timer: ReturnType<typeof setTimeout> | null = null;
export const CLEAR_AFTER_MS = 30_000;

export async function copyText(text: string, clear: boolean): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    return false;
  }
  if (timer) clearTimeout(timer);
  timer = null;
  if (clear) {
    timer = setTimeout(() => {
      navigator.clipboard
        .readText()
        .then((cur) => {
          if (cur === text) void navigator.clipboard.writeText("");
        })
        // Some browsers refuse clipboard reads; overwrite anyway.
        .catch(() => void navigator.clipboard.writeText("").catch(() => {}));
    }, CLEAR_AFTER_MS);
  }
  return true;
}

export function download(filename: string, data: BlobPart, type = "text/plain"): void {
  const url = URL.createObjectURL(new Blob([data], { type }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1_000);
}
